import { Capacitor } from '@capacitor/core';

/** True only when running inside a native Capacitor shell (Android / iOS). */
export function isNative() {
  return Capacitor.isNativePlatform();
}

export function getPlatform() {
  return Capacitor.getPlatform(); // 'android' | 'ios' | 'web'
}
